import type { SelfReportConfirmationFreeFormAnswersResponse } from '@/features/operation-packages/api';
import type { SelfReportConfirmationQuestionColumn, SelfReportConfirmationRow } from './type';
type ApiRow = SelfReportConfirmationFreeFormAnswersResponse['items'][number];
export function mapSelfReportConfirmationQuestionColumns(questionColumns: SelfReportConfirmationFreeFormAnswersResponse['questionColumns']): SelfReportConfirmationQuestionColumn[] {
  return questionColumns.map(column => ({
    questionDefinitionId: column.questionDefinitionId,
    name: column.name
  }));
}
export function mapSelfReportConfirmationRow(row: ApiRow): SelfReportConfirmationRow {
  return {
    instanceId: row.instanceId,
    person: {
      id: row.person.id,
      name: row.person.name,
      avatarUrl: row.person.avatarUrl ?? undefined
    },
    department: row.department ?? '',
    status: row.status,
    answeredAt: row.answeredAt,
    answers: row.answers
  };
}